import { AppDatabase } from '../../db';
import { v4 as uuidv4 } from 'uuid';
import Cleave from 'cleave.js';

document.addEventListener('DOMContentLoaded', () => 
{
    'use strict'

    // App settings
    const settings = require('/settings.js');
    const xss = require("xss");
    const pwaBrand = settings.settings.pwaBrand; // Define the current brand to be applied
    const pwaName = settings.settings.pwaName; //Local Storage Names for PWA
    const isAJAX = settings.settings.isAJAX; // AJAX transitions. Requires local server or server
    const db = new AppDatabase();

    // Analytics
    var _paq = window._paq = window._paq || [];

    // Naughty window properties
    window.settings = settings.settings;
    window.pwaBrand = pwaBrand;
    window.api = {};
    window.pwaName = pwaName;
    window.db = db;
    window.mapboxMap = null; 
    window.timeout;
    window.lastTap = 0;
    window.imageData = [];
    window.messagesLoading = false;
    window.xss = xss;
    window.appEnv = null;
    window.menuActive = true;
    window.uuid = uuidv4;
    window.Cleave = Cleave;
   
    //Place all your custom Javascript functions and plugin calls below this line
    function init_template()
    {	 
        //Caching Global Variables
        var i, e, el; //https://www.w3schools.com/js/js_performance.asp 

        window.newChat = false;
        if (typeof window.actionTimer !== "undefined")
        {
            clearInterval(window.actionTimer);
            window.actionTimer = undefined;
        }

        if (typeof window.globalChatCountTimer !== "undefined")
        {
            clearInterval(window.globalChatCountTimer);
            window.globalChatCountTimer = undefined;
        }

        if (typeof window.ChatCountTimer !== "undefined")
        {
            clearInterval(window.ChatCountTimer);
            window.ChatCountTimer = undefined;
        }

        if (typeof window.chatReadTimer !== "undefined")
        {
            clearInterval(window.chatReadTimer);
            window.chatReadTimer = undefined;
        }

        if (typeof window.chatPageReadTimer !== "undefined")
        {
            clearInterval(window.chatPageReadTimer);
            window.chatPageReadTimer = undefined;
        }

        // Form overlay
        window.form_loading = function(elmnt, showHide, delay)
        {
            if (typeof elmnt === "undefined" || !elmnt)
            {
                return false;
            }

            // Invalid showHide value
            var acceptedValues = new Array("block", "none", "hide", "show");
            if ( acceptedValues.indexOf(showHide) == -1 )
            {
                return false; 
            }

            // Get the overlay
            var overlay = elmnt.getElementsByClassName('overlay');
            if (!overlay || !overlay[0])
            {
                return false;
            }
            overlay = overlay[0];

            // No element found
            if ( overlay === null || !overlay ){
                console.error('Element is of type null' );
                return false; 
            }  

            if ( typeof delay === "undefined" || isNaN(delay) ){
                if (showHide == 'hide' || showHide == 'none'){
                    delay = 800; 
                } 
                else {
                    delay = 1;
                } 
            }

            if (showHide == 'hide'){
                showHide = 'none';
            }
            if (showHide == 'show'){
                showHide = 'block';
            }

            /**
             * Show/hide the overlay with a delay
             * so that the sheet can show first before
             * removing overlay
             */
            setTimeout(function() {
                overlay.style.display = showHide;
            }, delay);
            
            return true; 
        } 

        // App pre-loader
        window.preloader = function(display)
        {
            let preloader = document.getElementById('preloader');
                
            if ( ['show', 'block'].includes(display) )
            {
                preloader.classList.add('bg-fade-white');
                preloader.classList.remove('preloader-hide');
            }
            else if ( ['hide', 'none'].includes(display) )
            {
                preloader.classList.remove('bg-fade-white');
                preloader.classList.add('preloader-hide');
            }
        }
        // Get current page
        window.current_page = function()
        {
            const url = document.location.pathname.split('/');
            let urlPart = url[url.length - 1];
            const currentPage = urlPart.replace(/\.[^/.]+$/, "");

            return currentPage !== ''
                ? currentPage
                : 'index';
        };
        // Get current directory URI
        window.current_directory_uri = function()
        {
            // Split into directories
            let currentUrl = window.location.href.split('/');
            // Remove last array element
            currentUrl.splice(-1);
            // Glue URL back with slash
            let newUrl = currentUrl.join('/');
            // Add slash at the end if needed
            if (newUrl.substring(newUrl.length-1, newUrl.length) != '/') 
            {        
                newUrl = newUrl + '/';           
            }
            return newUrl;
        };

        //Detecting Mobile OS
        let isMobile = {
            Android: function() {return navigator.userAgent.match(/Android/i);},
            iOS: function() {return navigator.userAgent.match(/iPhone|iPad|iPod/i);},
            any: function() {return (isMobile.Android() || isMobile.iOS());}
        };

        //Attaching Menu Hider
        const menuHider = document.getElementsByClassName('menu-hider');
        if(!menuHider.length){document.body.innerHTML += '<div class="menu-hider"></div>';}

        //Activating Menus
        document.querySelectorAll('.menu').forEach(el=>{el.style.display='block'})

        // Hide all menu-active
        document.querySelectorAll('.menu-active').forEach(el=>{el.classList.remove('menu-active')});

        //Don't jump on Empty Links
        const emptyHref = document.querySelectorAll('a[href="#"]:not([data-menu="menu-main-sidebar"])')
        emptyHref.forEach(el => el.addEventListener('click', e => {
            e.preventDefault();
            return false;
        }));

        /**
         * PAGE LEVEL SCRIPTS
         */
        import('./view.js').then(({ View }) =>
        {
            const appView = new View(db);
            appView.execute(window.current_page(), isMobile).then((res) =>
            {
                return res;
            }).catch((ex) =>
            {
                console.error(ex);
                return false;
            });
        }).catch( (ex) =>
        {
            console.error(ex);
        });
        
        //Card Extender
        const cards = document.getElementsByClassName('card');
        if(cards.length)
        {
            card_extender(cards);
            window.addEventListener("resize", card_extender);
        }

        var linkListToggle = document.querySelectorAll('[data-trigger-switch]:not([data-toggle-theme])');
        if(linkListToggle.length)
        {
            linkListToggle.forEach(el => el.addEventListener('click', event =>
            {
                var switchData = el.getAttribute('data-trigger-switch');
                var getCheck =  document.getElementById(switchData);
                getCheck.checked ? getCheck.checked = false : getCheck.checked = true;
            }))
        }
     
        //Accordion Rotate
        const accordionBtn = document.querySelectorAll('.accordion-btn');
        if(accordionBtn.length)
        {
            accordionBtn.forEach(el => el.addEventListener('click', event => 
            {
                el.querySelector('i:last-child').classList.toggle('fa-rotate-180');
            }));
        }

        // Javascript works, remove the no-js class from <body> element
        document.getElementsByTagName('body')[0].classList.remove('no-js');

        //Collapse Flip Icon
        var collapseBtn = document.querySelectorAll('[data-bs-toggle="collapse"]:not(.no-effect)');
        if(collapseBtn.length){
            collapseBtn.forEach(el => el.addEventListener('click',e =>{
                if(el.querySelectorAll('i').length){
                    el.querySelector('i').classList.toggle('fa-rotate-180')
                };
            }));
        }

        //Tabs
        var tabTrigger = document.querySelectorAll('.tab-controls a');
        if(tabTrigger.length)
        {
            tabTrigger.forEach(function(e)
            {
                if(e.hasAttribute('data-active'))
                {
                    var highlightColor = e.parentNode.getAttribute('data-highlight');
                    e.classList.add(highlightColor);
                    e.classList.add('no-click');
                }
            });
            tabTrigger.forEach(el => el.addEventListener('click',e =>
            {
                var highlightColor = el.parentNode.getAttribute('data-highlight');
                var tabParentGroup = el.parentNode.querySelectorAll('a');
                tabParentGroup.forEach(function(e)
                {
                    e.classList.remove(highlightColor);
                    e.classList.remove('no-click');
                });
                el.classList.add(highlightColor);
                el.classList.add('no-click');
            }));
        }
 
        /**
         * Load plugins after view execution
         */
        loadPlugins();
        
        // Analytics
        // import(/*webpackIgnore: true*/ './utils/utils.js').then(({ getSubdomain }) =>
        // {
        //     // Analytics only on production
        //     const subdomain = getSubdomain();
        //     if (subdomain == 'prodza')
        //     {
        //         import(/*webpackIgnore: true*/ './utils/analytics.js').then(({ addAnalytics }) =>
        //         {
        //             addAnalytics();
        //         }).catch( (err) =>
        //         {
        //             console.log("Failed to load analytics.js", err)
        //         });
        //     }
        // }).catch( (err) =>
        // {
        //     console.log("Failed to load utils.js", err)
        // });
    }

    //Fix Scroll for AJAX pages.
    if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';

    //Initialize SwupJS
    if(isAJAX === true)
    {
        if(window.location.protocol !== "file:")
        { 
            let options = {
                containers: ["#page"],
                cache:false,
                animateHistoryBrowsing: false,
                linkSelector: window.settings.swupLinkSelector,
                plugins: [],
            };

            if ( typeof SwupPreloadPlugin !== "undefined" )
            {
                options.plugins = [
                    new SwupPreloadPlugin()
                ];
            }
            new Swup(options); 
            
            document.addEventListener('swup:pageView',(e) => 
            { 
                init_template(); 
            });

            import('./utils/event-listeners.js').then(({ destroyEvents }) =>
            {
                document.addEventListener('swup:willReplaceContent', (e) => 
                {
                    destroyEvents(db);
                });
            }).catch(ex =>
            {
                console.error(ex);
            });
        }
    }

    /*
    * ----------------
    *  EVENT HANDLERS
    * ----------------
    */ 

    import('./utils/event-listeners.js').then(({ 
        clickEventHandler,
        changeEventHandler, 
        inputEventHandler, 
        newCardListener, 
        scrollEventHandler,
        delayEvent
    }) =>
    {
        // Input event handler
        document.addEventListener('input', inputEventHandler);
        // Change event handler
        document.addEventListener('change', function(e)
        {
            changeEventHandler(e, db);
        }, false);
        // Built-in listener
        newCardListener();

        // Click events
        document.addEventListener('click', async function(e)
        {
            clickEventHandler(e, db);
        }, true);

        // Scroll events
        document.addEventListener('scroll', delayEvent( scrollEventHandler, 300))
    }).catch((ex) =>
    {
        console.error(ex);
    });

    init_template();

    function card_extender(cards)
    {
        let headerHeight, footerHeight;
        const headerOnPage = document.querySelectorAll('.header:not(.header-transparent)')[0];
        const footerOnPage = document.querySelectorAll('#footer-bar')[0];

        headerOnPage ? headerHeight = document.querySelectorAll('.header')[0].offsetHeight : headerHeight = 0
        footerOnPage ? footerHeight = document.querySelectorAll('#footer-bar')[0].offsetHeight : footerHeight = 0

        for (let i = 0; i < cards.length; i++) 
        {
            if(cards[i].getAttribute('data-card-height') === "cover")
            {
                if (window.matchMedia('(display-mode: fullscreen)').matches) {var windowHeight = window.outerHeight;}
                if (!window.matchMedia('(display-mode: fullscreen)').matches) {var windowHeight = window.innerHeight;}
            }
            if(cards[i].hasAttribute('data-card-height'))
            {
                const getHeight = cards[i].getAttribute('data-card-height');
                cards[i].style.height= getHeight +'px';
                if(getHeight === "cover")
                {
                    const coverHeight = windowHeight - headerHeight - footerHeight + 'px';
                    cards[i].style.height =  coverHeight
                }
            }
        }
    }

    function loadPlugins()
    {
        var plugLoc = "./plugins/"

        let plugins = [
            {
                id: 'gallery',
                plug: 'glightbox/glightbox.js',
                call: 'glightbox/glightbox-call.js',
                style: 'glightbox/glightbox.css',
                trigger: '[data-gallery]'
            }, 
        ];

        for (let i = 0; i < plugins.length; i++) 
        {
            //Remove Previous Calls
            if(document.querySelectorAll('.'+plugins[i].id+'-c').length)
            {
                document.querySelectorAll('.'+plugins[i].id+'-c')[0].remove();                
            }
            
            //Load Plugins
            var plugTrigger = document.querySelectorAll(plugins[i].trigger);

            if(1 == 1)
            {
                var loadScript = document.getElementsByTagName('script')[1],
                    loadScriptJS = document.createElement('script');

                loadScriptJS.type = 'text/javascript';
                loadScriptJS.className = plugins[i].id+'-p';
                loadScriptJS.src = plugLoc + plugins[i].plug;

                loadScriptJS.addEventListener('load',function()
                {
                    //Once plugin is loaded, load the call.
                    if(plugins[i].call !== undefined){
                        var callFn = document.getElementsByTagName('script')[2],
                            callJS = document.createElement('script');

                        callJS.type = 'text/javascript'
                        callJS.className = plugins[i].id+'-c'
                        callJS.src =  plugLoc + plugins[i].call
                        callFn.parentNode.insertBefore(callJS, callFn);
                    } 
                });
                //If plugin doesn't exist, load it
                if(!document.querySelectorAll('.'+plugins[i].id+'-p').length && plugins[i].plug !== undefined)
                {
                    loadScript.parentNode.insertBefore(loadScriptJS, loadScript);
                } 
                else 
                {
                    //If plugin doesn't exist, only load the call function
                    setTimeout(function()
                    {
                        var loadScript = document.getElementsByTagName('script')[1],
                            loadScriptJS = document.createElement('script');
                        loadScriptJS.type = 'text/javascript'
                        loadScriptJS.className = plugins[i].id+'-c'
                        loadScriptJS.src = plugLoc + plugins[i].call;
                        loadScript.parentNode.insertBefore(loadScriptJS, loadScript);
                    },50);
                }
                //If Style doesn't exist in array, don't do anything
                if(plugins[i].style !== undefined){
                    //if style already exists, don't re-add to page.
                    if(!document.querySelectorAll('.'+plugins[i].id+'-s').length){
                        var loadCSS = document.createElement("link");
                        loadCSS.className = plugins[i].id+'-s';
                        loadCSS.rel = "stylesheet";
                        loadCSS.type = "text/css";
                        loadCSS.href = plugLoc + plugins[i].style;
                        document.getElementsByTagName("head")[0].appendChild(loadCSS);
                    }
                }
            }
        }
        return true;
    }
});